import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { BllProgramAyarlari } from './../../../providers/bll/bll-programayarlari';
import { Component } from '@angular/core';
import {NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { NL_ProgramAyarlari } from '../../../models/NL_ProgramAyarlari';


@Component({
  selector: 'page-program-ayarlari',
  templateUrl: 'program-ayarlari.html',
})
export class ProgramAyarlariPage {
  cariListesayisi: number = 0;
  malzemelistesayisi: number = 0;
  SatisFaturasiStoktanDussunmu: number = 0;  //1 ise evet 0 ise hayır
  evethayir = [];
  fisyazicioto:number=0;
  Yazicilar=[];
  yazici:any={ID:-1,ADI:""};
  FisYaziciAdi="";
  BarkodYazici="";
  secilenyazici:string;
  constructor(public navCtrl: NavController,
    public ortak: Ortak,
    public bllOrtak:BllOrtak,
    public navParams: NavParams) {
 
    this.evethayir = [{
      "ID": "0",
      "Adi": "Hayır"
    },
    {
      "ID": "1",
      "Adi": "Evet"
    }
    ];
  }

  ionViewDidLoad() {
this.ayarlarigetir();
this.YazicilariGetir();
  }
  ayarlarigetir()
  {
    var bllprogramayarlari = new BllProgramAyarlari();
    bllprogramayarlari.getAll().then(a => {
      var sonuc = <any>a;
      this.cariListesayisi = sonuc[0].CariListeSayisi;
      this.malzemelistesayisi = sonuc[0].MalzemeListeSayisi;
      this.SatisFaturasiStoktanDussunmu = sonuc[0].SatisFaturasiStoktanDusecekMi;
      this.fisyazicioto=sonuc[0].fisyazicioto;
      this.FisYaziciAdi=sonuc[0].FisYaziciAdi;
      this.BarkodYazici=sonuc[0].BarkodYaziciAdi;
    });
  }
  YazicilariGetir()
  {
    this.bllOrtak.islemWithoutPost("YazicilariVer","",false).then(a=>{
      var sonuc=<any>a;
      this.Yazicilar=sonuc.SonucObject;
 
    })
  }

Kaydet()
{

  var bllayar=new BllProgramAyarlari();
  var guncellenecekElement = new NL_ProgramAyarlari();
  guncellenecekElement.CariListeSayisi = this.cariListesayisi;
  guncellenecekElement.MalzemeListeSayisi=this.malzemelistesayisi;
  guncellenecekElement.SatisFaturasiStoktanDusecekMi=this.SatisFaturasiStoktanDussunmu;
  guncellenecekElement.fisyazicioto=this.fisyazicioto;
  guncellenecekElement.FisYaziciAdi=this.FisYaziciAdi;
  guncellenecekElement.BarkodYaziciAdi=this.BarkodYazici;
  guncellenecekElement.ID = 1;
  bllayar.CariListeSayisiGuncelle(guncellenecekElement);
  bllayar.MalzemeListeSayisiGuncelle(guncellenecekElement);
  bllayar.SatisFaturasiAyariGuncelle(guncellenecekElement);
  bllayar.FisYaziciAdiGuncelle(guncellenecekElement);
  bllayar.BarkodYaziciGuncelle(guncellenecekElement);
  bllayar.FisYaziciOtomatigiGuncelle(guncellenecekElement);
  this.ortak.storageProgramAyarEkle(guncellenecekElement);
  this.ortak.showBasicAlert("Bilgi", "Ayarlar  güncellendi.");
  this.ayarlarigetir();
  
}
}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/program-ayarlari/program-ayarlari.ts